var _staticId = sas.ltjs.isOpenUI ? 'sap-ui-static' : 'graph-ui-static';
export function getStaticSpace() {
    var staticSpace = document.getElementById(_staticId);
    if (staticSpace) {
        return staticSpace;
    }
    staticSpace = document.createElement('div');
    staticSpace.id = _staticId;
    staticSpace.style.height = '0px';
    staticSpace.style.width = '0px';
    // NOTE(legacy): was style.float before (dead code)
    staticSpace.style.cssFloat = 'left';
    document.body.insertBefore(staticSpace, document.body.firstElementChild);
    return staticSpace;
}
